export interface ApiErrorInit {
  status: number;
  code?: string;
  type?: string;
  detail?: string;
  details?: unknown;
  payload?: unknown;
  messageKey?: string;
}

export class ApiError extends Error {
  status: number;
  code?: string;
  type?: string;
  detail: string;
  details?: unknown;
  payload?: unknown;
  messageKey?: string;

  constructor(status: number, message: string, options: ApiErrorInit = { status }) {
    const detail = options.detail ?? message;
    super(detail);
    this.name = 'ApiError';
    this.status = status;
    this.code = options.code;
    this.type = options.type;
    this.detail = detail;
    this.details = options.details;
    this.payload = options.payload;
    this.messageKey = options.messageKey;
  }
}

export const isApiError = (error: unknown): error is ApiError =>
  error instanceof ApiError;
